export const hexToString = (hex: number): string => {
  if (hex === 0) {
    return "00";
  }
  return hex.toString(16).toUpperCase();
};
